module.exports = __webpack_public_path__ + "img/max2.134e781b.svg";